import { ProductFeature } from "@app/shared/types";
import { routes } from "app/routes";
import { push } from "connected-react-router";
import UpdateBillingForm from "features/member/membership/UpdateBillingForm";
import { NotFoundPage } from "features/pages/NotFoundPage";
import _ from "lodash";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { MemberContext } from "../MemberZone";

export const MembershipUpdateBilling = () => {
    const context = useContext(MemberContext);
    const membership = _.first(context.memberships);
    const dispatch = useDispatch();

    if (!membership) {
        return <NotFoundPage />;
    }

    if (!membership.billingChoice.plan.features.includes(ProductFeature.ELIGIBLE_FOR_ADD_ONS)) {
        // if this person has a mentorship group, but isn't yet on sliding scale pricing, route them to the new pricing flow
        dispatch(push(routes.memberUpdateLegacyBillingPage1()));
        return <></>;
    }

    return <UpdateBillingForm membership={membership} />;
};
